import React,{ useEffect, useState, useRef } from 'react';
import '../styles/Landingpage.css';
import SelectedProjects from "./SelectedProjects";
import AboutMe from "./About-me";
import StacksSection from "./StacksSection";
import { FaSun, FaMoon, FaTimes, FaLinkedin, FaGithub, FaEnvelope } from 'react-icons/fa';
import { BiLogoGmail } from "react-icons/bi";
import CollaborationSection from "./CollaborationSection";

const LandingPage = () => {
    // State to manage the themes
    const [isDarkMode, setIsDarkMode] = useState(false);
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const overlayRef = useRef(null);  //this solves the problem that: When hamburger menu is clicked to open the overlay, the handleClickOutside function detects the
    // click and closes the menu right away since the click event is not directly on the .menu-overlay.
    // This Happens because the click event is being fired on the hamburger menu itself, which is outside the .menu-overlay.

    const menuContentRef = useRef(null);
    const [activeOption, setActiveOption] = useState('recruiters');

    // Function to open and close the overlay menu
    const toggleMenu = () => setIsMenuOpen(!isMenuOpen);
    const closeMenu = () => setIsMenuOpen(false);

    // Toggle theme function
    const toggleTheme = () => {
        setIsDarkMode(!isDarkMode);
        document.documentElement.setAttribute(
            'data-theme',
            isDarkMode ? 'light' : 'dark'
        );
        localStorage.setItem('theme', isDarkMode ? 'light' : 'dark');
    };

    // Function to handle the button click and open the email client
    const handleEmailClick = () => {
        window.location.href = 'mailto:fr.ajuluchukwu@gmail.com'; // This will open the default email client
    };

    // Option texts
    const texts = {
        Anyone: "Hello there, I'm a passionate software developer and UX/UI designer who cares about making beautiful " +
            "things that help people. Whether it's crafting intuitive user interfaces, exploring a new domain or building efficient code, I aim to deliver quality work.",
        Recruiters: "I’m a product designer with 5 years of experience...",
        DesignDirectors: "I take pride in my craft...",
        ProductDesigners: "I’m a systems thinker with a high bar for quality, I bring end-to-end product acumen...",
        Engineers: "I’m highly technical and can collaborate closely with engineers..."
    };

    const [showInfoPopup, setShowInfoPopup] = useState(false);
    // Function to toggle the popup visibility
    const toggleInfoPopup = () => {
        setShowInfoPopup(true);}
    setTimeout(() => setShowInfoPopup(false), 3000); // Auto-hide after 3 seconds



        // Set theme on initial load
    useEffect(() => {
        const savedTheme = localStorage.getItem('theme') || 'light';
        if (savedTheme === 'dark') {
            setIsDarkMode(true);
            document.documentElement.setAttribute('data-theme', 'dark');
        }
    }, []);

    useEffect(() => {
        localStorage.setItem('theme', isDarkMode ? 'dark' : 'light');
    }, [isDarkMode]);

    // Handle clicks outside the menu to close it
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (isMenuOpen && overlayRef.current && !menuContentRef.current.contains(event.target))
            {
                closeMenu();
            }
        };
        document.addEventListener('click', handleClickOutside);
        return () => {
            document.removeEventListener('click', handleClickOutside);
        };
    }, [isMenuOpen]);

    return (
        <div className="landing-page">
            {/* Theme Toggle Button */}
            <div className="theme-toggle">
                <input
                    type="checkbox"
                    id="theme-switch"
                    checked={isDarkMode}
                    onChange={toggleTheme}
                />
                <label htmlFor="theme-switch" className="toggle-slider">
                    <div className={`icon-container ${isDarkMode ? 'dark' : 'light'}`}>
                        {isDarkMode ? <FaMoon className="icon moon-icon"/> : <FaSun className="icon sun-icon"/>}
                    </div>
                </label>
            </div>

            {/* Hamburger Menu */}
            <div
                className={`hamburger-menu ${isMenuOpen ? 'open' : ''}`}
                onClick={toggleMenu}
                // onMouseEnter={() => setIsMenuOpen(true)}
                // onMouseLeave={() => setIsMenuOpen(false)}
            >
                <div className="menu-line"></div>
                <div className="menu-line"></div>
                <div className="menu-line"></div>
            </div>

            {/* Slide-in Overlay Menu */}
            <div className={`menu-overlay ${isMenuOpen ? 'show' : ''}`}>
                <nav className="menu-content">
                    {/* Close Button */}
                    <button className="close-button" onClick={closeMenu}>
                        <FaTimes/></button>
                    <a href="=#about-me" className="menu-item">About me</a>
                    <a href="=#selected-projects" className="menu-item">Projects</a>
                    <a href="#collabo-section" className="menu-item"   onClick={(e) => {
                        e.preventDefault(); // Prevent navigation
                        toggleInfoPopup();
                    }}> Other works</a>  {showInfoPopup && (
                    <div className="info-popup">
                        <p>Coming soon</p>
                    </div>
                )}
                </nav>
            </div>

            {/* Hero Section */}
            <header className="hero-section">
                <h1 className="hero-title">Hi there </h1>
                <p className="hero-subtitle">I build clean, modern, and user-friendly interfaces.</p>
                <a href="#mailto:fr.ajuluchukwu@gmail.com" className="cta-button" onClick={handleEmailClick}>Get in
                    Contact</a>
            </header>

            <section className="section intro">
                <div className="content">
                    <div className="gradient-mask left"></div>
                    <div className="gradient-mask right is--visible"></div>

                    {/* options section */}
                    <div className="options">
                        {Object.keys(texts).map(key => (
                            <div
                                key={key}
                                className={`option ${activeOption === key ? 'is--active' : ''}`}
                                onClick={() => setActiveOption(key)}
                            >
                                {key.replace(/([A-Z])/g, ' $1')}
                            </div>
                        ))}
                    </div>

                    {/* options text section */}
                    <div className="texts">
                        {Object.keys(texts).map(key => (
                            <h1
                                key={key}
                                className={`text ${activeOption === key ? 'is--visible' : ''}`}
                            >
                                {texts[key]}
                            </h1>
                        ))}
                    </div>
                </div>
            </section>

            <StacksSection/>

            {/* About Section */}
            <section className="about-section">
                {/*<h2>Selected Projects</h2>*/}
                <SelectedProjects/>
                <p>
                    Gonna paste more project work here.
                </p>
            </section>

            {/*<section className="Aboutme-section">*/}
            {/*    <AboutMe/>*/}
            {/*</section>*/}

            <section className="collabo-section">
                <CollaborationSection/>
            </section>

            {/* Footer with social media links */}
            <footer className="social-links">
                <a href="https://www.linkedin.com/in/franklin-ajuluchukwu-b872101a3/" target="_blank"
                   rel="noopener noreferrer" className="social-link">
                    <FaLinkedin className="social-icon"/>
                </a>
                <a href="https://github.com/Prismaticode" target="_blank" rel="noopener noreferrer"
                   className="social-link">
                    <FaGithub className="social-icon"/>
                </a>
                <a href="mailto:fr.ajuluchukwu@gmail.com" className="social-link">
                    <BiLogoGmail className="social-icon"/>
                </a>
            </footer>


        </div>
    );
};

export default LandingPage;
